// extracted by mini-css-extract-plugin
export default {"login":"styles_login__1VUHd","loginForm":"styles_loginForm__CWkQE","logoWrap":"styles_logoWrap__dgKu8","logo":"styles_logo__4FtZk","errorMsg":"styles_errorMsg__Ec46X"};